export default {
  title: '共付额',
  description: '共付额是您根据保险计划规定，需为涵盖的医疗服务或处方支付的特定金额。',
  'is-paid': '已支付',
}
